import { actionCreator } from 'utils';
import * as PaymentTypeTypes from '../types/paymentTypeTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    offset: 0,
    limit: 50,
    isSubmitting: false,

    edit: {
        loading: false,
        data: null,
        error: false,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case PaymentTypeTypes.LOAD_PAYMENT_TYPE:
        return Object.assign({}, state, {
            ...state,
            loading: true,
        });
    case actionCreator(PaymentTypeTypes.LOAD_PAYMENT_TYPE, 'err'):
        return Object.assign({}, state, {
            ...state,
            loading: false,
            error: true,
        });
    case actionCreator(PaymentTypeTypes.LOAD_PAYMENT_TYPE, 'res'):
        return Object.assign({}, state, {
            ...state,
            loading: false,
            listing: action.data,
        });

    case PaymentTypeTypes.SET_PAYMENT_TYPE_PAGINATION:
        return Object.assign({}, state, {
            ...state,
            [action.key]: action.pagination,
        });

    case PaymentTypeTypes.EDIT_PAYMENT_TYPE:
        return Object.assign({}, state, {
            ...state,
            isSubmitting: true,
        });
    case actionCreator(PaymentTypeTypes.EDIT_PAYMENT_TYPE, 'err'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });
    case actionCreator(PaymentTypeTypes.EDIT_PAYMENT_TYPE, 'res'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });

    case PaymentTypeTypes.ADD_PAYMENT_TYPE:
        return Object.assign({}, state, {
            ...state,
            isSubmitting: true,
        });
    case actionCreator(PaymentTypeTypes.ADD_PAYMENT_TYPE, 'err'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });
    case actionCreator(PaymentTypeTypes.ADD_PAYMENT_TYPE, 'res'):
        return Object.assign({}, state, {
            ...state,
            isSubmitting: false,
        });

    case PaymentTypeTypes.LOAD_EDITABLE_PAYMENT_TYPE:
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                loading: true,
            },
        });
    case actionCreator(PaymentTypeTypes.LOAD_EDITABLE_PAYMENT_TYPE, 'err'):
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                loading: false,
                error: true,
            },
        });
    case actionCreator(PaymentTypeTypes.LOAD_EDITABLE_PAYMENT_TYPE, 'res'):
        return Object.assign({}, state, {
            ...state,
            edit: {
                data: action.data,
                loading: false,
                error: false,
            },
        });

    case PaymentTypeTypes.SET_EDITABLE_PAYMENT_TYPE_DATA:
        return Object.assign({}, state, {
            ...state,
            edit: {
                ...state.edit,
                data: action.data,
            },
        });

    default:
        return state;
    }
}
